import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constanst } from 'src/app/core/constants/constans.component';

@Component({
  selector: 'app-dialog-information',
  templateUrl: './dialog-information.component.html',
  styleUrls: ['./dialog-information.component.css']
})
export class DialogInformationComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  specification: string;
  reference: string;
  description: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogSpecificationRef: MatDialogRef<DialogInformationComponent>
  ) { }

  ngOnInit(): void {
    this.specification = this.data.specification;
    this.reference = this.data.reference;
    this.description = this.data.description;
  }

  closeDialogSpecification() {
    this.dialogSpecificationRef.close();
  }

}
